module.exports = __webpack_public_path__ + "static/media/chair.75c51e13.png";